import { baseApi } from "@/shared/api";
import { fileResponseHandler, type FileResponse } from "@/shared/utils";
import type { GetWorkersQueryParams, WorkerListItem, WorkersListResponse, RehireWorkerRequest, RehireWorkerResponse } from "../types";
import type { WorkerDetailResponse } from "../pages/WorkerDetailPage/types";

export const workersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkers: builder.query<WorkersListResponse, GetWorkersQueryParams | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();

        if (params?.status) searchParams.append("status", params.status);
        if (params?.search) searchParams.append("search", params.search);

        return {
          url: `/api/hr/workers/?${searchParams.toString()}`,
          method: "GET",
          credentials: "include",
        };
      },
      transformResponse(response: WorkersListResponse | WorkerListItem[]) {
        if (Array.isArray(response)) {
          return { workers: response, import_drafts: [] };
        }
        return response;
      },
      providesTags: [{ type: "NGOWorkers" as const, id: "LIST" }],
    }),

    downloadWorkerProfilePreview: builder.mutation<FileResponse, number>({
      query: (id) => ({
        url: `/api/hr/workers/${id}/preview-profile/`,
        method: "GET",
        responseHandler: fileResponseHandler,
      }),
    }),

    rehireWorker: builder.mutation<RehireWorkerResponse, RehireWorkerRequest>({
      query: (body) => ({
        url: "/api/hr/workers/rehire/",
        method: "POST",
        body,
        credentials: "include",
      }),
      invalidatesTags: [{ type: "NGOWorkers" as const, id: "LIST" }],
    }),

    getWorkerDetail: builder.query<WorkerDetailResponse, number>({
      query: (id) => ({
        url: `/api/hr/workers/${id}/`,
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: (_result, _error, id) => [{ type: "WorkerDetail" as const, id }],
    }),
  }),
});

export const {
  useGetWorkersQuery,
  useDownloadWorkerProfilePreviewMutation,
  useRehireWorkerMutation,
  useGetWorkerDetailQuery,
} = workersApi;

